module.exports = __webpack_public_path__ + "static/media/monis.0f9e8300.jpg";